import React from 'react';

const AboutSection = () => {
    return (
        <section className="w-full flex items-center justify-center dark:bg-earth-900 py-20 overflow-hidden">
            <div className="w-full max-w-7xl px-8 lg:px-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
                    <div className="flex flex-col justify-center">
                        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-earth-900 dark:text-earth-50 leading-tight mb-6">
                            About Me
                        </h2>

                        <p className="text-base sm:text-lg text-earth-800 dark:text-earth-100 leading-8 mb-10">
                            I'm a <span className="font-semibold">Master's Student in Computer Science</span> at Sapienza University of Rome, passionate about exploring cutting-edge technologies and solving real-world problems.
                        </p>

                        <div>
                            <h3 className="text-lg sm:text-xl font-bold text-earth-900 dark:text-earth-50 mb-4">
                                Interests
                            </h3>
                            <div className="flex flex-wrap gap-2">
                                {[
                                    'Machine Learning',
                                    'Deep Learning',
                                    'Computer Vision',
                                    'Natural Language Processing',
                                    'Reinforcement Learning',
                                    'Software Development',
                                ].map((interest) => (
                                    <div
                                        key={interest}
                                        className="rounded-full border border-earth-800 bg-white/20 dark:bg-earth-800/30 dark:border-earth-100/30 px-4 py-2 text-sm sm:text-base font-medium text-earth-900 dark:text-earth-50"
                                    >
                                        {interest}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col justify-center">
                        <div className="rounded-3xl border border-earth-800 dark:border-earth-100/20 bg-white/20 dark:bg-earth-800/20 p-6 sm:p-8 shadow-[0_12px_40px_rgba(0,0,0,0.04)]">
                            <div className="mb-5 h-px w-14 bg-earth-900/70 dark:bg-earth-50/70" />
                            <h3 className="text-lg sm:text-xl font-bold text-earth-900 dark:text-earth-50 mb-6">
                                Side Quests
                            </h3>
                            <p className="text-base sm:text-lg text-earth-800 dark:text-earth-100 leading-8">
                                Beyond coding, I have a passion for photography. In the <span className="font-semibold">Wallpapers</span> section, you'll find a curated collection of original photographs available for free download. Feel free to use them on your devices!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;

